import React, { useEffect, useRef, useState } from "react";

const AppUpdateNotifier = () => {
  const [showUpdate, setShowUpdate] = useState(false);
  const [releaseNote, setReleaseNote] = useState<string>("");
  const currentTimestamp = useRef<string | null>(null);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch("/version.json", { cache: "no-cache" });
        const data = await response.json();
        const latestTimestamp = data?.timestamp?.toString().trim();

        if (
          currentTimestamp.current &&
          latestTimestamp !== currentTimestamp.current
        ) {
          setReleaseNote(data?.releaseNote?.trim() || "");
          setShowUpdate(true);
        } else {
          currentTimestamp.current = latestTimestamp;
        }
      } catch (error) {
        console.error("⚠️ Version check failed:", error);
      }
    };

    checkVersion(); // initial
    const interval = setInterval(checkVersion, 10000); // check every 10 seconds
    return () => clearInterval(interval);
  }, []);

  if (!showUpdate) return null;

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center p-2"
      style={{ zIndex: 9999, backgroundColor: "rgba(0,0,0,0.7)" }}
    >
      <div
        className="card shadow-lg border-0 overflow-hidden"
        style={{ maxWidth: "420px", width: "100%" }}
      >
        <div className="card-body text-center p-4">
          {/* Icon */}
          <div className="mb-3">
            <i
              className="bx bxs-rocket text-dark"
              style={{ fontSize: "2.5rem" }}
            ></i>
          </div>

          {/* Heading */}
          <h5 className="card-title text-dark fw-semibold mb-2">
            New Version Available
          </h5>
          <p className="card-text text-muted mb-3">
            Please reload the page to get the latest updates.
          </p>

          {/* Release notes */}
          {releaseNote ? (
            <div
              className="text-start text-dark mb-3 p-3 rounded"
              style={{
                backgroundColor: "#f3f5f7",
                maxHeight: "160px",
                overflowY: "auto",
                whiteSpace: "pre-line",
                lineHeight: 1.6,
              }}
            >
              {releaseNote}
            </div>
          ) : null}

          {/* Button */}
          <button
            className="btn btn-dark px-4"
            onClick={() => window.location.replace(window.location.href)}
          >
            Refresh Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppUpdateNotifier;
